
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 9A9 9 0 110 9a9 9 0 0118 0z","fill":"#F1F1F1"}}),_c('path',{attrs:{"d":"M9.01 10.735V8.999s2.595 0 2.595-1.736c0-1.735-.86-2.603-2.595-2.603-1.736 0-2.612.868-2.612 2.603m2.604 6.075h.008","stroke":"#A6ADB5","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    